import { BaseMutations } from '@/store/base-mutations';
import { RepairStatuses } from '@/enums';
import { SimpleEnumType } from '@/types';
import { Repairs } from '../../../types';
import WarrantyState from './state';
import { default_new_component } from '../../../services';

export default class WarrantyMutations extends BaseMutations<WarrantyState> {
  TOGGLE_LOADING_WARRANTY(toggle: boolean) {
    this.state.warranty_loading = toggle;
  }

  SET_WARRANTY_DATA(data: Repairs.Warranty[]) {
    this.state.warranty_data = data;

    if (data) {
      data.forEach((warranty: Repairs.Warranty) => {
        this.state.extended_warranties = warranty.extended_warranties ? warranty.extended_warranties : [];
      });
    }
  }
}
